module.exports = __webpack_public_path__ + "img/1013.b9512cef.jpg";